// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"f364501b","75":"f3f9ee8e","220":"f3f668b1","241":"96cf1095","467":"63dee9c6","787":"5a191258","814":"fb7f55e8","952":"ea8b5223"}[chunkId] + ".chunk.js";
};